export enum TipoRetencaoPISCOFINSEnum {

  PIS_COFINS_CSLL_NAO_RETIDO = "0 - PIS/COFINS/CSLL Não Retidos",
  RETIDO = "1 - PIS/COFINS Retido",
  NAO_RETIDO = "2 - PIS/COFINS Não Retido",
  PIS_COFINS_CSLL_RETIDO = "3 - PIS/COFINS/CSLL Retidos",
  PIS_COFINS_RETIDO_CSLL_NAO_RETIDO = "4 - PIS/COFINS Retidos, CSLL Não Retido",
  PIS_RETIDO_COFINS_CSLL_NAO_RETIDO = "5 - PIS Retido, COFINS/CSLL Não Retidoo",
  COFINS_RETIDO_PIS_CSLL_NAO_RETIDO = "6 - COFINS Retido, PIS/CSLL Não Retido",
  PIS_NAO_RETIDO_COFINS_CSLL_RETIDO = "7 - PIS Não Retido, COFINS/CSLL Retidos",
  PIS_COFINS_NAO_RETIDO_CSLL_RETIDO = "8 - PIS/COFINS Não Retidos, CSLL Retido",
  COFINS_NAO_RETIDO_PIS_CSLL_RETIDO = "9 - COFINS Não Retido, PIS/CSLL Retidos;"

}
